module.exports = __webpack_public_path__ + "assets/img/rank4.aca0c55c.png";